import React from "react";
import { useNavigate } from 'react-router-dom';
import ListProxyUsingComponent from "../../../components/Customer/proxies/ListProxyUsingComponent";

const ListProxyUsingPage = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-proxy/chuyen-khach-hang.html?' + listVps);
    }

    return <ListProxyUsingComponent
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default ListProxyUsingPage;